<template>
  <b-container
    fluid
    class="d-flex flex-column align-items-center justify-content-center min-vh-100"
  >
    <h1>페이지를 찾을 수 없습니다.</h1>
    <b-btn variant="primary" class="mt-4 text-noto py-2 px-4" to="/">
      메인페이지로 이동
    </b-btn>
  </b-container>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
